import React from 'react'
import { useTranslation } from 'react-i18next';
import './scrollTopBtn.scss';

import BtnArrowTop from '../../images/btn-arrow-top.svg';

const headerHeight = 64;

const ScrollTopBtn = () => {
    const { t } = useTranslation();

    const scrollToRow = (elemId) => {
        const offsetTop =  document.querySelector('#' + elemId).offsetTop;
        window.scrollTo({
            top: offsetTop - headerHeight,
            behavior: 'smooth'
        });
    }

    return (
        <div id="scroll_top_btn"
            onClick={() => {scrollToRow('top_intro')}}
        >
            <img src={BtnArrowTop} alt='^'/>
            <div className='btn-scroll-text'>{t('btnGoTop')}</div>            
        </div>
    )
}

export default ScrollTopBtn;
